module.exports = __webpack_public_path__ + "img/picto-operateur-moins.1cef8561.svg";